module.exports = __webpack_public_path__ + "static/contact_mobile-35a9b385088f4031ed6e860911a7d495.jpg";